import { useCallback } from 'react'
import { useTenant } from '@/contexts/TenantContext'

export function useTenantKey() {
  const { currentTenant } = useTenant()
  const tenantId = currentTenant?.id
  // Memoised so callers can safely put it in an effect dependency array.
  return useCallback(
    <T extends readonly unknown[]>(...parts: T) => ['tenant', tenantId, ...parts] as const,
    [tenantId],
  )
}
